import React from 'react'
import Input from 'base/react/components/form/input'
import FlatButton from 'base/react/components/flat_button'
import classNames from 'classnames'
import RouterLink from 'base/components/router_link'

function PasswordResetEmailForm({ email, onChange, onSubmit, error }) {
  const labelClassName = classNames('password-reset__label', {
    'password-reset__label--error': error,
  })

  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        onSubmit()
      }}
      style={{ position: 'relative' }}
    >
      <Input
        required
        autofocus
        inputCLass="password-reset__input"
        label="Email Address"
        labelClass={labelClassName}
        error={error}
        errorClass="password-reset__input--error"
        inputClass="password-reset__input"
        type="email"
        name="emailInput"
        value={email || ''}
        onChange={onChange}
      />
      <FlatButton
        color="dark-grey"
        onClick={onSubmit}
        className="password-reset__button"
        disabled={!email}
      >
        Send Reset Link
      </FlatButton>

      <p className="password-reset__contact">
        Need more help?{' '}
        <RouterLink href="https://everlane.com/contact-us" className="password-reset__contact-link">
          Contact us
        </RouterLink>
        .
      </p>
    </form>
  )
}

export default PasswordResetEmailForm
